import React from 'react';
import TextField, { type TextFieldProps } from '@mui/material/TextField';

export type AppTextFieldProps = TextFieldProps;

/** MUI TextField with design-system defaults (`size="small"`, outlined, full width). */
const AppTextField = React.forwardRef<HTMLDivElement, AppTextFieldProps>(function AppTextField(
  { size = 'small', variant = 'outlined', fullWidth = true, ...props },
  ref,
) {
  return <TextField ref={ref} size={size} variant={variant} fullWidth={fullWidth} {...props} />;
});

export default AppTextField;
